module.exports = __webpack_public_path__ + "static/media/youtube.bff2f772.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Icons/youtube.svg
// module id = 266
// module chunks = 0